import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { SkillScoreAnalysis } from "lib/resume-scoring/types";
import { SectionCard } from "./SectionCard";
import { StatusItem } from "./StatusItem";

export const SkillsCard = ({
  score,
  maxScore,
  analysis,
  className = "",
}: {
  score: SkillScoreAnalysis;
  maxScore: number;
  analysis: ResumeAnalysis["skills"];
  className?: string;
}) => {
  let statementIssueFound = false;
  for (const skill of analysis.descriptionAnalysis) {
    if (skill) {
      statementIssueFound = true;
      break;
    }
  }
  
  const isEmptyState = analysis.descriptionAnalysis.length === 0;
  
  return (
    <SectionCard
      title="Skills"
      icon="personalDetails"
      score={score.totalScore}
      maxScore={maxScore}
      detailsLink="/score-check/skills"
      emptyState={isEmptyState}
      className={className}
    >
      <ul className="mb-3 mt-3 gap-y-3 overflow-auto">
        <StatusItem
          icon="noIssue"
          title="No issue found"
          subtitle="Good impact in score"
          status="success"
        />
      </ul>
    </SectionCard>
  );
};
